// Parses the `whodunnit` value attached to PaperTrail-backed audit rows.
// Real-user whodunnits are emitted by the Rails ApplicationController as
// `name::email::id::type` (see app/controllers/api/application_controller.rb
// #user_for_paper_trail in bidops-app). System/ICO use bare snake_case
// sentinels; callers should special-case those (e.g. translated label) before
// calling this — the parser returns null when the input isn't structured,
// signaling "not a real user."

const DELIMITER = '::';

export const SYSTEM_WHODUNNIT = 'system';
export const ICO_WHODUNNIT = 'intelligent_counter_offer';

// The actor classifications a structured whodunnit can carry. SYSTEM and
// INTELLIGENT_COUNTER_OFFER are intentionally NOT in this union — they're
// represented by the bare sentinels above and never produce a ParsedWhodunnit.
export type WhodunnitType = 'ARKESTRO' | 'CONTRACTOR' | 'STANDARD';

export interface ParsedWhodunnit {
  email: string;
  id: number;
  name: string;
  type: WhodunnitType;
}

// Returns the parsed user actor, or null when `raw` is a bare sentinel (system,
// ICO, anything else without the `::` delimiter). Caller renders sentinels via
// their own i18n / display rules and uses `parsed.name | parsed.email | parsed.id |
// parsed.type` for the structured case.
export const parseWhodunnit = (raw: string): ParsedWhodunnit | null => {
  if (!raw.includes(DELIMITER)) return null;

  const [name = '', email = '', idStr = '', typeStr = ''] = raw.split(DELIMITER);
  return {
    email,
    id: Number(idStr),
    name,
    type: (typeStr as WhodunnitType) || 'STANDARD'
  };
};
